import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      subMenuList: [
        {
          id: 1,
          label: '整期推送',
          expanded: false,
          type: 1,
          colCode: 'new_zqts'
        },
        {
          id: 2,
          label: '专题推送',
          expanded: false,
          type: 2,
          colCode: 'new_ztts'
        },
        {
          id: 4,
          label: '单篇推送',
          expanded: false,
          type: 4,
          colCode: 'new_dpts'
        },
        {
          id: 3,
          label: '通知推送',
          expanded: false,
          type: 3,
          colCode: 'new_tzts'
        }
      ],
      subscribeTypes: [
        {
          label: '被引订阅推送',
          value: 7
        },
        {
          label: '期刊订阅推送',
          value: 8
        },
        {
          label: '学科订阅推送',
          value: 9
        },
        {
          label: '关键词订阅推送',
          value: 10
        },
        {
          label: '专题订阅推送',
          value: 11
        },
        {
          label: '优先出版订阅推送',
          value: 12
        },
        {
          label: '会议通知订阅推送',
          value: 13
        }
      ],
      citationTypes: [
        {
          label: '被引推送',
          value: 6
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['isMedicalAssociationEnv', 'isCluster']),
    ...mapGetters('incrementService', ['getZdtsChildrenList']),
    emailTypes() {
      let data = []
      if (this.isMedicalAssociationEnv) {
        data = this.subMenuList.filter((item) =>
          this.getZdtsChildrenList.some((it) => it.colCode === item.colCode)
        )
      } else {
        data = this.subMenuList
      }
      return data.map((item) => {
        return {
          ...item,
          value: item.id
        }
      })
    }
  },
  watch: {
    isCluster: {
      handler(nv) {
        // 集群并且是医学会显示主题推送
        if (nv && this.isMedicalAssociationEnv) {
          this.subMenuList.splice(2, 0, {
            id: 5,
            label: '主题推送',
            expanded: false,
            type: 5,
            colCode: 'new_stts'
          })
        }
      },
      immediate: true
    }
  }
}
